import { ModuleTableOfContents } from 'types/learningHub/moduleContents';

export const areAllLessonsCompleted = (data: ModuleTableOfContents | undefined) => {
  return data?.chapters?.every((chapter) =>
    chapter?.lessons?.filter((lesson) => lesson.kind !== 'Test').every((lesson) => lesson?.isCompleted)
  );
}

export const areAllChapterTestsCompleted = (data: ModuleTableOfContents | undefined) => {
  const hasChapterTests = data?.chapters?.some((chapter) => chapter?.lessons?.some((lesson) => lesson.kind === 'Test'));
  return !hasChapterTests || data?.chapters?.every((chapter) =>
    chapter?.lessons?.filter((lesson) => lesson.kind === 'Test').every((test) => test?.status === 'Completed')
  );
}

export const areAllCertificationsCompleted = (data: ModuleTableOfContents | undefined) => {
  const hasCertifications = (data?.certifications?.length ?? 0) > 0;
  return !hasCertifications || data?.certifications?.every((certification) => certification?.status === 'Completed');
}

export const isModuleCompleted = (data: ModuleTableOfContents | undefined) => {
  const allLessonsCompleted = areAllLessonsCompleted(data);
  const allChaptersCompleted = areAllChapterTestsCompleted(data);
  const allCertificationsCompleted = areAllCertificationsCompleted(data);
  return (allLessonsCompleted && allChaptersCompleted && allCertificationsCompleted) || false;
};

export const isModuleStarted = (data: ModuleTableOfContents | undefined) => {
  return data?.chapters?.flatMap((chapter) => chapter?.lessons).some((lesson) => lesson?.isCompleted) || false;
};
